import { useLocation, useSearchParams } from 'react-router-dom';
import { Slide, Stack, styled } from '@mui/material';

import { TOPBAR_HEIGHT } from '@/styles/constant';
import ProjectList from '@/components/projects/ProjectList';
import ProjectDetail from '@/components/projects/ProjectDetail';

export const PROJECT_SIDEBAR_WIDTH = 800;
const Layout = styled(Stack)`
  position: absolute;
  top: 0;
  width: ${PROJECT_SIDEBAR_WIDTH}px;
  height: calc(100vh - ${TOPBAR_HEIGHT}px);
  background: #F7F9FA;
  padding: 1.5rem;
  overflow: hidden;
  z-index: 2;  
`;

export default function Projects() {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const projectId = searchParams.get('projectId') ?? '';

  return (
    <Slide in={location.pathname === '/projects'} direction="right">
      <Layout gap={3}>{projectId === '' ? <ProjectList /> : <ProjectDetail />}</Layout>
    </Slide>
  );
}
